<template>
    <div class="page-header-container">
        <div v-show="!isAssessmentBarRemoved" class="row-container">
            <v-row class="pt-1">
                <v-col
                    cols="12"
                    class="p-0 d-flex flex-row justify-content-center "
                >
                    <div 
                        class="readiness-row d-flex flex-column justify-content-center align-items-center "
                    >   
                        <div class="w-100 top-text">Assess your organization's CMMC posture</div>
                        <!-- <div class="w-100 top-text">Test your knowledge to ensure that your business is cyber-secure</div> -->
                        <!-- <div class="mt-2 bottom-text">Assess your organization's CMMC posture</div> -->
                    </div>
                </v-col>

                <v-col
                    cols="12"
                    class="p-0 pt-2 d-flex flex-row justify-content-center align-items-center"
                    :class="assessmentRowStyle"
                >
                    <v-btn
                        outlined
                        rounded
                        :color="'#fff'"
                        @click="goToTaskAssessment"
                    >
                        Start Now
                    </v-btn>
                </v-col>
            </v-row>
        </div>

        <section v-show="showBackgroundImage" :style='{ backgroundImage: `url("${itemBgImg}")` }' class="page-header-bg-image">
            <div v-if="itemBgImgHasOverlay" class="page-header-overlay" :style="{ 'backgroundColor': `rgba(0, 0, 0, ${itemBgImgOpacity})` }">
            </div>
            <div class="container p-0">
                <v-row id="page-header-row-container" :class="pageHeaderStyle">
                    <slot></slot>
                </v-row>
            </div>
        </section>
    </div>
</template>

<script>
    import { EventBus } from '../../../utils/eventBus';
    export default {
        props: {
            isAssessmentBarRemoved: {
                type: Boolean,
                default: false,
            },
            showBackgroundImage: {
                type: Boolean,
                default: true,
            },
            pageHeaderBackgroundImageSrc: {
                type: String,
                default: require("../../../assets/images/HomepageBannerHeader.png"),
            },
            hasOverlay: {
                type: Boolean,
                default: false,
            },
            headerBackgroundOpacity: {
                type: Number,
                default: 0.25,
            }
        },
        data(){
            return {
                itemBgImg: this.pageHeaderBackgroundImageSrc,
                itemBgImgOpacity: this.headerBackgroundOpacity,
                itemBgImgHasOverlay: this.hasOverlay,
            };
        },
        computed: {
            pageHeaderStyle() {
                return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) ? 'page-header-mobile' : 'page-header-desktop';
            },
            assessmentRowStyle(){
                return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) ? 'mt-3' : 'mt-0';
            },
        },
        methods: {
            goToTaskAssessment(){
                this.$router.push("cyber-readiness-check");
                EventBus.$emit("activate-indicated-menu-item", "Resources");
            },
        },
        watch: {
            pageHeaderBackgroundImageSrc(newValue){
                if(newValue) {
                    const img = new Image();

                    img.onload = () => {
                        this.itemBgImg = img.src;
                    };

                    img.onerror = () => {
                        this.itemBgImg = require("../../../assets/images/HomepageBannerHeader.png");
                        this.itemBgImgHasOverlay = false;
                        this.itemBgImgOpacity = 0.25;
                    };

                    img.src = newValue;
                }
            }
        },
    }
</script>

<style scoped>
    .page-header-container {
        width: 100%;
        height: auto;
        /* margin-bottom: 12px; */
    }
    .page-header-bg-image {
        position: relative;
        /* background-image: url('../../../assets/images/HomepageBannerHeader.png'); */
        background-position: center center;
        background-size: cover;
        min-width: 340px;
        margin-top: 90px;
    }
    .page-header-overlay {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1000;
    }
    .row-container {
        min-width: 250px;
        position: relative;
        background-color: #424EC4;
        top: 80px;
        padding-top: 35px;
        padding-bottom: 35px;
    }
    .page-header-desktop {
        min-height: 350px;
    }
    .page-header-mobile {
        min-height: 200px;
        padding-top: 20px;
        padding-bottom: 20px;
    }
    .readiness-row {
        width: auto;
        height: auto;
        font-family: Rajdhani;
        font-style: normal;
        line-height: normal;
        color: #fff;
        text-align: left;
        /* padding-left: 20px;
        padding-right: 20px; */
    }
    .readiness-row .top-text {
        font-size: 18px;
        font-weight: 700;
    }
    .readiness-row .bottom-text {
        font-size: 14px;
        font-weight: 400;
        text-align: center;
    }
</style>